import { of } from 'rxjs';
import { EligibilityFn } from '../lib/eligibility.interfaces';

export const NoContractEligibility: () => EligibilityFn = () => () =>
  of({ eligible: true });
